<div class="modal-content view-modal-content">
  <div class="modal-header content-header">
    <button type="button"
            class="close close-btn"
            aria-label="Close"
            mat-dialog-close
    >
      <i class="fa fa-close fa-md"></i>
    </button>
    <h4 class="modal-title">
      View Files
      <i class="fa fa-spin fa-spinner" *ngIf="fileLoader"></i>
    </h4>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="!isReadOnly">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div>
          <h3 class="mt-2 mb-0 py-2">
            Search
          </h3>
          <div class="row px-4">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 px-0 p-2 mb-3">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex px-2 py-2"
                     style="border: 1px solid #a82b41;">
                  <i class="fa fa-search mt-2 mr-2"></i>
                  <input placeholder="By Name" style="border: 0px;" type="text" [(ngModel)]="searchText">
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 p-2 px-0"
                   [ngClass]="isMobileDevice?'ml-0 mt-0':'ml-0 mb-3'">
                <div class="col-md-12 col-lg-10 col-xs-12 d-flex px-2 py-2" style="border: 1px solid #a82b41;">
                  <span>FileType</span>
                  <select style="width: 100%;border: 0px;" [(ngModel)]="selectedAircraftFileType">
                    <option value="" selected>All</option>
                    <option *ngFor="let value of fileTypes" [value]="value">
                      {{ value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-3 flex-wrap" style="justify-content: space-between; align-items: center;">
      <div>
        <span><b>Total Files: </b></span>
        <span class="badge badge-pill badge-danger text-info"><i class="fa fa-upload"></i>{{ totalCount }}</span>
      </div>
      <div class="mt-xs-1">
        <input type="file"
               class="cursorPointer mt-2 d-none"
               accept=".jpg,.jpeg,.png,.pdf"
               id="vendorDetailFile"
               multiple
               #fileInput
               name="multipleFilePopup"
               (input)="memberFileUpload($event)"
        />
        <a class="py-2 px-3 mr-2 button_style cursorPointer"
           *ngIf="isAddButtonVisible()"
           (click)="openServiceRequestFile('vendorDetailFile')"
        >
          Add File
        </a>
        <a class="py-2 px-3 mr-2 cursorPointer button_style_edit"
           (click)="editAllFile()"
           *ngIf="isEditButtonVisible()"
        >
          Edit File
        </a>
        <a class="py-2 px-3 mr-2 cursorPointer button_style_save"
           (click)="submitMultipleFile()"
           *ngIf="isSaveButtonVisible()"
        >
          Save
        </a>
        <button type="button"
                class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                *ngIf="editAllFile1"
                (click)="closeAll()"
        >
          <i class="fa fa-close fa-md"></i>
        </button>
        <button type="button"
                class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                *ngIf="editAllFile1"
                (click)="closeViewFileModel()"
                data-dismiss="modal"
        >
          <i class="fa fa-check fa-md"></i>
        </button>
      </div>
    </div>
    <div class="tableMargin">
      <table class="table border-table mb-2" data-sort="false">
        <thead class="table-thead">
        <tr>
          <td class="header_td p-2" style="border-bottom:1px !important;">
            <div class="header_container">
              <div class="header_title cursorPointer" (click)="sortColumn('fileNameColumn','fileName')">
                <span>File Name</span>
                <i *ngIf="fileNameColumn" class="fa fa-chevron-up margin-left-7"></i>
                <i *ngIf="!fileNameColumn" class="fa fa-chevron-down margin-left-7"></i>
              </div>
              <div class="header_title cursorPointer" (click)="sortColumn('uploadedOnColumn','createdOn')">
                <span>Uploaded On</span>
                <i *ngIf="uploadedOnColumn" class="fa fa-chevron-up margin-left-7"></i>
                <i *ngIf="!uploadedOnColumn" class="fa fa-chevron-down margin-left-7"></i>
              </div>
              <div *ngIf="data.isTagRequired" class="header_title cursorPointer" (click)="sortColumn('fileTagColumn','fileAttachmentTagName')">
                <span>File Tags</span>
                <i *ngIf="fileTagColumn" class="fa fa-chevron-up margin-left-7"></i>
                <i *ngIf="!fileTagColumn" class="fa fa-chevron-down margin-left-7"></i>
              </div>
              <div class="header_title cursorPointer" (click)="sortColumn('fileCreatedByColumn','creatorName')">
                <span>Created By</span>
                <i *ngIf="fileCreatedByColumn" class="fa fa-chevron-up margin-left-7"></i>
                <i *ngIf="!fileCreatedByColumn" class="fa fa-chevron-down margin-left-7"></i>
              </div>
              <div class="header_title action">
                Action
              </div>
            </div>
          </td>
        </tr>
        </thead>
        <ng-container *ngIf="!fileLoader">
          <tbody>
          <tr
            *ngFor="let file of files
                  | orderBy: sortFileType:sortOrder:prioritySorting
                  | filter: searchText
                  | SearchByCategory: selectedAircraftFileType
                  | paginate: { itemsPerPage: pageSize, currentPage: currentPage, totalItems: totalCount };
                  trackBy: trackByFn;
                  let i= index">
            <td>
              <div class="row_container">
                <div class="title_container">
                  <div class="row_title">File Name</div>
                  <div class="row_detail text-color cursorPointer"
                       style="word-break: break-word;"
                       *ngIf="!file.isEditable"
                  >
                    <a class="text-color" (click)="downloadFile(file)">
                      {{ file.displayName }}
                    </a>
                    <sup *ngIf="file.uploadedFrom == 'Itinary' || file.uploadedFrom == 'ServiceRequestStep'">
                            <span class="badge" [ngClass]="{
                                'bg-red':file.uploadedFrom=='Itinary',
                                'bg-green':file.uploadedFrom=='ServiceRequestStep'
                            }">
                              {{
                                file.uploadedFrom == 'Itinary' ? 'SR File' :
                                  (file.uploadedFrom == 'ServiceRequestStep' ? 'Leg File' : '')
                              }}
                            </span>
                    </sup>
                  </div>
                  <div *ngIf="file.isEditable" class="d-flex">
                    <input type="text" placeholder="File Name" class="form-control mr-2"
                           [(ngModel)]="file.displayName" name="file_name_edit{{i}}" id="file_name_edit{{i}}">
                    <span class="mt-2"></span>
                  </div>
                </div>
                <div class="title_container">
                  <div class="row_title">Uploaded On</div>
                  <div class="row_detail">
                    <b>{{ file?.createdOn | ToLocalDate }}</b>
                  </div>
                </div>
                <div *ngIf="data.isTagRequired" class="title_container">
                  <div class="row_title">File Tags</div>
                  <div class="row_detail">
                    <select *ngIf="file.isEditable"
                            class="form-control"
                            name="file_tag{{i}}"
                            id="file-tag{{i}}"
                            [(ngModel)]="file.fileAttachmentTagId"
                    >
                      <option [value]="null"
                              selected
                              disabled
                      >
                        Select file attachment tag
                      </option>
                      <option *ngFor="let tag of fileAttachmentTagOptionList"
                              [value]="tag.appCategoryId"
                      >
                        {{ tag.appCategoryName }}
                      </option>
                    </select>
                    <span *ngIf="!file.isEditable && file?.fileAttachmentTagName"
                          class="break-word badge"
                          [ngClass]="fileAttachmentTagStatusClass[file?.fileAttachmentTagName]"
                    >
                            {{ file?.fileAttachmentTagName }}
                          </span>
                  </div>
                </div>
                <div class="title_container">
                  <div class="row_title">Created By</div>
                  <div class="row_detail" style="word-break: break-word;">
                    {{ file?.creatorName }}
                  </div>
                </div>
                <div class="title_container">
                  <div class="row_title">Action</div>
                  <div class="row_detail">
                    <button *ngIf="!file.isEditable"
                            class="flat-butt save-btn delete-icon"
                            type="button"
                            title="Add Priority"
                            [disabled]="isReadOnly"
                            [class.cursorDisabled]="isReadOnly"
                            (click)="pinItem(file)"
                    >
                      <i class="fa fa-star" [class.notePriority]="file?.isPinned"></i>
                    </button>

                    <button type="button"
                            class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                            [disabled]="isReadOnly"
                            [ngClass]="isReadOnly ? 'cursorDisabled' : ''"
                            *ngIf="!file.isEditable"
                            title="Edit {{file?.fileType}} file"
                            (click)="fileEdit(file)"
                    >
                      <i class="fa fa-pencil-square"></i>
                    </button>

                    <ng-container *ngIf="!isCustomerOrVendorCoordinator && data.isFileEditable">
                      <button type="button"
                              class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                              [disabled]="isReadOnly"
                              [ngClass]="isReadOnly ? 'cursorDisabled' : ''"
                              *ngIf="!file.isEditable"
                              title="Delete {{file?.fileType}} file"
                              data-dismiss="modal"
                              (click)="removeFile(file)">
                        <i class="fa fa-minus-circle"></i>
                      </button>
                    </ng-container>
                    <button type="button"
                            class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                            *ngIf="file.isEditable"
                            title="Cancel"
                            (click)="closeDisable(file)"
                    >
                      <i class="fa fa-close fa-md"></i>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </ng-container>
        <ng-container *ngIf="fileLoader">
          <div class="row my-4">
            <div class="d-flex justify-content-center">
              <div class="dot-pulse"></div>
            </div>
          </div>
        </ng-container>
      </table>
      <ng-container *ngIf="files?.length === 0 && !fileLoader">
        <div class="row my-4">
          <div class="d-flex justify-content-center">
                <span class="text-danger">
                  <b>No record found!</b>
                </span>
          </div>
        </div>
      </ng-container>
      <div class="row my-4" *ngIf="!!files?.length && !fileLoader">
        <div class="d-flex justify-content-center">
          <pagination-controls [maxSize]="6"
                               previousLabel=""
                               nextLabel=""
                               (pageChange)="onPageChange($event)">
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
